// extracted by mini-css-extract-plugin
export var component = "layout-module--component--3ivdp";
export var componentWidthFull = "layout-module--component-width-full--CSR6B";
export var componentWidthNarrow = "layout-module--component-width-narrow--e7htW";